<div class="flex flex-col justify-center items-center text-center">
	<h4>Are you sure you would like to delete the following document?</h4>
	<p>This is a permanent action and cannot be undone.</p>

	<div
		class="flex items-center py-2 px-4 border-gray-400 border rounded-xl w-fit mt-3 max-w-sm"
	>
		<app-icon [icon]="ICON.FILE_COMPLETE" class="mr-3 text-lg"></app-icon>
		<p class="whitespace-nowrap text-ellipsis overflow-hidden">
			{{ documentName }}
		</p>
	</div>
</div>

<div class="flex justify-between mt-10">
	<app-button btn="border" class="mr-5" (click)="cancelModal()"
		>Keep</app-button
	>
	<app-button btn="error" (click)="deleteDocument()">Delete</app-button>
</div>
